import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export default function ContentLoading() {

    return (
        <div className="d-flex justify-content-center">
            <CircularProgress sx={{color: '#303956'}}/>
        </div>
    )
}